import { api } from "./api";
import type { ChickPurchase } from "@/types/models";

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const chickPurchaseService = {
  create: (data: {
    shed_id: number;
    destination_shed_id: number;
    date: string;
    bird_count: number;
    cost_per_bird?: number;
    supplier_id?: number;
    breed_id?: number;
    notes?: string;
    attachment_ids?: number[];
  }) =>
    api
      .post<ChickPurchase>("/chick-purchases", data)
      .then((r) => r.data),
  list: (params?: Record<string, string | number>) =>
    api
      .get<PaginatedResponse<ChickPurchase>>("/chick-purchases", { params })
      .then((r) => r.data),
  get: (id: number) =>
    api
      .get<ChickPurchase>(`/chick-purchases/${id}`)
      .then((r) => r.data),
  update: (
    id: number,
    data: {
      bird_count: number;
      cost_per_bird?: number;
      supplier_id?: number;
      date: string;
      notes?: string;
    }
  ) =>
    api
      .put<ChickPurchase>(
        `/chick-purchases/${id}`,
        data
      )
      .then((r) => r.data),
  // confirmPaid: the owner has seen "this bill has payments" and said delete.
  delete: (id: number, confirmPaid = false) =>
    api.delete(`/chick-purchases/${id}`, { params: confirmPaid ? { confirm_paid: "true" } : undefined }),
};
